<template>
  <div>
    <Head title="Paneli" />

    <div class="flex flex-wrap items-center mb-6 lg:mb-6">

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Nga data:</label>
        <input v-model="form.start_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label text-sm">Deri në datën(duke mos e përfshirë):</label>
        <input v-model="form.end_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label">Shteti:</label>
        <Multiselect
          v-model="form.country_ids"
          :options="filterCountries.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>


      <div class="pr-5 w-full lg:w-1/6">
        <label class="form-label">Qyteti:</label>
        <Multiselect
          v-model="form.city_ids"
          :options="filterCities.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>

      <div class="pr-5 w-full lg:w-1/6">
        <button class="mt-7 text-gray-500 hover:text-gray-700 focus:text-indigo-500 text-sm" type="button" @click="reset">Pastro</button>
      </div>
    </div>

    <div class="flex flex-wrap mx-2 mb-6 lg:mb-6">
      <h3 class="text-sm font-bold pr-6 w-full lg:w-full">Dërgesa
        <hr></h3>
      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-yellow-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(1)">{{this.ordersData.created}}</Link>
        </h1>
        <h1 class="text-2xl text-white">Të regjistruara</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5  mr-5 mt-2  w-full lg:w-1/6 bg-indigo-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(2)">{{ this.ordersData.processing }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në proces</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-orange-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(3)">{{ this.ordersData.warehouse }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në depo</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2 w-full lg:w-1/6 bg-indigo-900 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(4)">{{ this.ordersData.shipping }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në shpërndarje</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-yellow-700 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(6)">{{ this.ordersData.pending }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Në pritje</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2 w-full lg:w-1/6 bg-green-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(5)">{{ this.ordersData.delivered }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Sukses</h1>
        <h1 v-if="this.ordersData.delivered_sales != null" class="text-sm text-white">Total shitje: {{parseFloat(this.ordersData.delivered_sales).toFixed(2)}}</h1>
        <h1 v-if="this.ordersData.delivered_shipping_cost != null" class="text-sm text-white">Total posta: {{parseFloat(this.ordersData.delivered_shipping_cost).toFixed(2)}}</h1>
        <h1 v-if="this.ordersData.delivered_sales != null" class="text-sm text-white">Total shuma NETO : {{parseFloat(netoDeliveredSales).toFixed(2) }}</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-red-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(7)">{{ this.ordersData.cancelled }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Të anuluara</h1>
        <h1 class="text-sm text-white">Total posta: {{this.ordersData.cancelled_cancelled_cost}}</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-gray-400 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(8)">{{ this.ordersData.returned }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Të kthyera</h1>
        <h1 class="text-sm text-white">Total posta: {{this.ordersData.returned_cancelled_cost}}</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2   w-full lg:w-1/6 bg-green-900 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getBarazuarOrdersUrl()">{{ this.ordersData.likujduar }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Të likuiduara</h1>
        <h1 v-if="this.ordersData.likujduar_sales != null" class="text-sm text-white">Total shitje: {{parseFloat(this.ordersData.likujduar_sales).toFixed(2)}}</h1>
        <h1 v-if="this.ordersData.likujduar_shipping_cost != null" class="text-sm text-white">Total posta: {{parseFloat(this.ordersData.likujduar_shipping_cost).toFixed(2)}}</h1>
        <h1 v-if="this.ordersData.likujduar_sales != null" class="text-sm text-white">Total shuma NETO : {{parseFloat(netoLikuiduarSales).toFixed(2) }}</h1>
      </div>
    </div>

    <div class="flex flex-wrap  space-y-4 lg:flex-nowrap lg:space-x-4 lg:space-y-0 mb-8 mt-5">
      <div class="overflow-hidden rounded-md shadow bg-white w-full lg:w-1/2">
        <canvas class="bg-white" id="sucessAndCancelChart" height="150"></canvas>
      </div>

      <div class="overflow-hidden rounded-md shadow bg-white w-full lg:w-1/2">
        <canvas class="bg-white" id="ordersByCountryChart" height="150"></canvas>
      </div>
    </div>

  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Chart from 'chart.js/auto';
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import mapValues from 'lodash/mapValues'
import Multiselect from '@vueform/multiselect'


export default {
  components: {
    Head,
    Link,
    Multiselect
  },
  layout: Layout,
  props: {
    ordersData: Object,
    dailyOrdersData: Object,
    ordersByCountry: Object,
    countries: Object,
    cities: Object,
    filters: Object
  },
  data(){
    return {
      form: {
        start_date: this.filters.start_date,
          end_date: this.filters.end_date,
          country_ids: this.filters.country_ids,
          city_ids : this.filters.city_ids,
      },
      filterCountries: {
        options: this.countries.map(function(country){
          return {value: country.id, label: country.name}
        }),
      },
      filterCities: {
        options: this.cities.map(function(country){
          return {value: country.id, label: country.name}
        }),
      },
    }
  },
  computed: {
    netoDeliveredSales(){
      return this.ordersData.delivered_sales - this.ordersData.delivered_shipping_cost
    },
    netoLikuiduarSales(){
      return this.ordersData.likujduar_sales - this.ordersData.likujduar_shipping_cost
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/paneli', pickBy(this.form), {
          preserveState: true,
          onSuccess: () => {
            this.updateOrdersByCountryBarChart()
            this.updateSucessAndCancelLineChart()
          }
        });

      }, 150),
    },
  },
  mounted() {
    this.generateSucessAndCancelLineChart()
    this.generateOrdersByCountryBarChart()
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
      let multiselectClearButtons = document.getElementsByClassName('multiselect-clear')
      for(let i = 0 ; i < multiselectClearButtons.length; i++){
        multiselectClearButtons[i].click()
      }
    },
    getTodayDate(){
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return yyyy + '-' + mm + '-' + dd;
    },
    getTomorrowDate(){
      var today = new Date();
      var dd = String(today.getDate() + 1).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return yyyy + '-' + mm + '-' + dd;
    },
    getOrdersByStatusUrl(statusId){
      let url = "/dergesat?status_ids[]=" + statusId + "&barazuar=false"
      if(this.filters.start_date)
        url += ("&start_date_status_updated=" + this.filters.start_date)

      if(this.filters.end_date)
        url += ("&end_date_status_updated=" + this.filters.end_date)

      if(this.filters.country_ids)
        this.filters.country_ids.forEach(function(key,value){
          url += ("&country_ids[]=" + key)
        })

      if(this.filters.city_ids)
        this.filters.city_ids.forEach(function(key,value){
          url += ("&city_ids[]=" + key)
        })

      if(this.filters.delivery_driver_ids)
        this.filters.delivery_driver_ids.forEach(function(key,value){
          url += ("&delivery_driver_ids[]=" + key)
        })

      return url;
    },
    getBarazuarOrdersUrl(){
      let url = "/dergesat?barazuar=true"
      if(this.filters.start_date)
        url += ("&start_date_barazuar=" + this.filters.start_date)

      if(this.filters.end_date)
        url += ("&end_date_barazuar=" + this.filters.end_date)

      if(this.filters.country_ids)
        this.filters.country_ids.forEach(function(key,value){
          url += ("&country_ids[]=" + key)
        })

      if(this.filters.city_ids)
        this.filters.city_ids.forEach(function(key,value){
          url += ("&city_ids[]=" + key)
        })

      if(this.filters.delivery_driver_ids)
        this.filters.delivery_driver_ids.forEach(function(key,value){
          url += ("&delivery_driver_ids[]=" + key)
        })

      return url;
    },
    generateOrdersByCountryBarChart(){
      const ordersByCountryChart = document.getElementById('ordersByCountryChart');

      return  new Chart(ordersByCountryChart, {
        type: 'bar',
        data: {
          labels: this.ordersByCountry.map(x => x.country),
          datasets: [{
            label: 'Dërgesat',
            data: this.ordersByCountry.map(x => x.orders),
            backgroundColor: [
              'rgba(148, 163, 184, 1)',
            ],
            borderColor: [
              'rgba(239, 68, 68, 1)',
            ],
            borderWidth: 1,

          }]
        },
        options: {
          scales: {
            y: {
              beginAtZero: true
            }
          }
        }
      });
    },
    updateOrdersByCountryBarChart(){
      const chart = Chart.getChart("ordersByCountryChart");
      chart.data.datasets[0].data = this.ordersByCountry.map(x => x.orders);
      chart.update()
    },
    generateSucessAndCancelLineChart(){
      const sucessAndCancelChart = document.getElementById('sucessAndCancelChart');

      return new Chart(sucessAndCancelChart, {
        type: 'line',
        data: {
          labels: this.dailyOrdersData.success.map(x => x.date),
          datasets: [{
            label: 'Të anuluara',
            data: this.dailyOrdersData.canceled.map(x => x.orders),
            backgroundColor: [
              'rgba(239, 68, 68, 1)',
            ],
            borderColor: [
              'rgba(239, 68, 68, 1)',
            ],
            borderWidth: 1,

          },
            {
              label: 'Sukses',
              data: this.dailyOrdersData.success.map(x => x.orders),
              backgroundColor: [
                'rgba(34, 197, 94, 1)',
              ],
              borderColor: [
                'rgba(34, 197, 94, 1)',
              ],
              borderWidth: 1,
              lineTension: 0.4,
            },
            {
              label: 'Të regjistruara',
              data: this.dailyOrdersData.created.map(x => x.orders),
              backgroundColor: [
                'rgb(234,179,8,1)',
              ],
              borderColor: [
                'rgb(234,179,8,1)',
              ],
              borderWidth: 1,
              lineTension: 0.4,
            },

          ]
        },
        options: {
          scales: {
            y: {
              beginAtZero: true
            }
          }
        }
      });
    },
    updateSucessAndCancelLineChart(){
      const chart = Chart.getChart("sucessAndCancelChart");
      chart.data.datasets[0].data = this.dailyOrdersData.canceled.map(x => x.orders);
      chart.data.datasets[1].data = this.dailyOrdersData.success.map(x => x.orders);
      chart.update()
    },
  }
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

